import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import './App.css';

import { AuthProvider, useAuth, homePathFor } from './context/AuthContext';
import { BookingProvider }       from './context/BookingContext';
import Header                    from './components/Header';
import ProtectedRoute            from './components/ProtectedRoute';
import LoginPage                 from './pages/LoginPage';
import RegisterPage              from './pages/RegisterPage';
import BookingFormPage           from './pages/BookingFormPage';
import MyBookingsPage            from './pages/MyBookingsPage';
import AdminDashboard            from './pages/AdminDashboard';
import BillPage from './pages/BillPage';
import NightDeskPage             from './pages/NightDeskPage';

const AUTH_PATHS = ['/login', '/register'];

function AppRoutes() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const isAuthPage = AUTH_PATHS.includes(location.pathname);
  return (
    <div className="bhu-app">
      {!isAuthPage && <Header />}
      <main className={isAuthPage ? 'bhu-main--auth' : 'bhu-main'}>
        <Routes>
          {/* Root redirect */}
          <Route path="/" element={
            currentUser
              ? <Navigate to={homePathFor(currentUser.role)} replace />
              : <Navigate to="/login" replace />
          } />

          {/* Public auth routes */}
          <Route path="/login" element={
            currentUser
              ? <Navigate to={homePathFor(currentUser.role)} replace />
              : <LoginPage />
          } />
          <Route path="/register" element={
            currentUser ? <Navigate to="/my-bookings" replace /> : <RegisterPage />
          } />

          {/* User routes */}
          <Route path="/rooms" element={
            <ProtectedRoute requiredRole="user"><BookingFormPage /></ProtectedRoute>
          } />
          <Route path="/my-bookings" element={
            <ProtectedRoute requiredRole="user"><MyBookingsPage /></ProtectedRoute>
          } />

          {/* Admin routes */}
          <Route path="/gh-admin" element={
            <ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/gh-admin/bill/:bookingId" element={
            <ProtectedRoute requiredRole="admin"><BillPage /></ProtectedRoute>
          } />

          {/* Night desk — the whole session is this one screen. requiredRole is
              an exact match (ProtectedRoute), so a night login typing any other
              route in the bar is bounced straight back here. */}
          <Route path="/night" element={
            <ProtectedRoute requiredRole="night"><NightDeskPage /></ProtectedRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BookingProvider>
          <AppRoutes />
        </BookingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
